import * as React from "react";
import {Button, icons} from "@vebox/etui-core";
import {BUTTON_STYLE} from "../common/etui_components_styles";
import {AppTranslations} from "../Utils/translations/AppTranslations";
import {Stylable} from "../common/PropsType";
import {Display} from "../Display";

import "./vebox-modal.scss";
import {LoadingButton} from "../buttons/LoadingButton";

declare var AppTranslations: AppTranslations;

interface HeaderProps extends Stylable {
    title: string | JSX.Element;
    onClose?: (...a: any[]) => void;
    titleClassName?: string;
}

interface StandardActionsProps extends Stylable {
    submitText?: string;
    cancelText?: string;
    canSubmit?: boolean;
    onSubmit: (...a: any[]) => void;
    onCancel: (...a: any[]) => void;
    useSubmitLoadingButton?: boolean;
    isSubmitLoading?: boolean;
    useCancelLoadingButton?: boolean;
    isCancelLoading?: boolean;
}

interface InfoActionsProps extends Stylable {
    cancelText?: string;
    onCancel: (...a: any[]) => void;
}

export class VeBoxModal extends React.Component<Stylable> {

    public static Backdrop: React.FC<React.HTMLAttributes<any>> = (props) => (
        <div {...props} className={"vebox-modal-backdrop " + (props.className ?? "")}>
            {props.children}
        </div>
    )

    public static Header: React.FC<HeaderProps> = (props) => (
        <div className={"vebox-modal-header " + (props.className ?? "")} style={props.style}>
            <div className={props.titleClassName ?? "vebox-modal-header-title"}>
                <h2>{props.title}</h2>
                <Display isVisible={props.onClose}>
                    <Button
                        onClick={props.onClose}
                        iconProps={{glyph: icons.CLOSE}}
                        className={"vebox-modal-close-button"}
                    />
                </Display>
            </div>
        </div>
    )

    public static Body: React.FC<Stylable> = (props) => (
        <div className={"vebox-modal-body " + (props.className ?? "")} style={props.style}>
            {props.children}
            <hr className={"vebox-modal-divider"}/>
        </div>
    )

    public static Section: React.FC<Stylable> = (props) => (
        <div className={"vebox-modal-section"}>
            <hr className={"vebox-modal-divider"}/>
            <div className={"vebox-modal-section-content " + (props.className ?? "")} style={props.style}>
                {props.children}
            </div>
        </div>
    )

    public static Actions: React.FC<Stylable> = (props) => (
        <VeBoxModal.Section className={"vebox-modal-action " + (props.className ?? "")} style={props.style}>
            {props.children}
        </VeBoxModal.Section>
    )

    public static StandardActions: React.FC<StandardActionsProps> = ({
                                                                         className,
                                                                         useCancelLoadingButton,
                                                                         useSubmitLoadingButton,
                                                                         isCancelLoading,
                                                                         isSubmitLoading,
                                                                         onCancel,
                                                                         onSubmit,
                                                                         canSubmit,
                                                                         submitText,
                                                                         cancelText,
                                                                         style
                                                                     }) => (
        <VeBoxModal.Actions className={className} style={style}>
            <Display isVisible={!useCancelLoadingButton}>
                <Button
                    onClick={onCancel}
                    styles={BUTTON_STYLE}
                    style={{minWidth: 70, textTransform: (cancelText ? "none" : "capitalize")}}
                    variant={"tertiary"}
                >
                    {cancelText || AppTranslations.genericWords.cancel}
                </Button>
            </Display>
            <Display isVisible={useCancelLoadingButton}>
                <LoadingButton
                    onClick={onCancel}
                    styles={BUTTON_STYLE}
                    style={{minWidth: 70, textTransform: (cancelText ? "none" : "capitalize")}}
                    variant={"tertiary"}
                    loading={isCancelLoading}
                >
                    {cancelText || AppTranslations.genericWords.cancel}
                </LoadingButton>
            </Display>
            <Display isVisible={!useSubmitLoadingButton}>
                <Button
                    onClick={onSubmit}
                    variant={"strong"}
                    disabled={canSubmit === false}
                    style={{minWidth: 70, textTransform: (submitText ? "none" : "capitalize")}}
                    styles={BUTTON_STYLE}
                >
                    {submitText || AppTranslations.genericWords.submit}
                </Button>
            </Display>
            <Display isVisible={useSubmitLoadingButton}>
                <LoadingButton
                    onClick={onSubmit}
                    variant={"strong"}
                    disabled={canSubmit === false}
                    style={{minWidth: 70, textTransform: (submitText ? "none" : "capitalize")}}
                    styles={BUTTON_STYLE}
                    loading={isSubmitLoading}
                >
                    {submitText || AppTranslations.genericWords.submit}
                </LoadingButton>
            </Display>

        </VeBoxModal.Actions>
    )

    public static InfoAction: React.FC<InfoActionsProps> = (props) => (
        <VeBoxModal.Actions className={props.className} style={props.style}>
            <Button
                onClick={props.onCancel}
                styles={BUTTON_STYLE}
                style={{minWidth: 70, textTransform: (props.cancelText ? "none" : "capitalize")}}
                variant={"tertiary"}
            >
                {props.cancelText || AppTranslations.genericWords.cancel}
            </Button>
        </VeBoxModal.Actions>
    )

    public render() {
        return (
            <div className={"vebox-modal " + (this.props.className ?? "")} style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}